// extracted by mini-css-extract-plugin
module.exports = {"threeFeatured":"threeFeatured___2cQGW","articles":"articles___1XXJB","gc":"gc___1h2Er"};